<template>
  <div>
    <component :is="ui.layout"></component>
    <!-- Offline indicator -->
    <div v-if="!isOnline" class="offline black">Tanpa koneksi</div>
    <div v-if="displayOnline" class="offline green">Kembali online</div>
  </div>
</template>

<script>
import Private from "@/layout/Private";
import Public from "@/layout/Public";
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
    Private,
    Public
  },
  data() {
    return {
      displayOnline: false
    };
  },
  computed: {
    ...mapState(["ui"])
  },
  watch: {
    isOnline(val) {
      if (val) {
        this.displayOnline = true;
        setTimeout(() => {
          this.displayOnline = false;
        }, 4000);
      }
    }
  }
};
</script>

<style>
.nowrap td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
table .expanded {
  width: 100%;
  border-collapse: collapse;
}
.expanded td:first-child {
  text-align: right;
  font-weight: bold;
  white-space: nowrap;
}
.expanded td:last-child {
  width: 100%;
}
.viewer {
  cursor: pointer;
}
.offline {
  position: fixed;
  width: 100%;
  padding: 3px;
  bottom: 0;
  color: #fff;
  font-size: 12px;
  text-align: center;
  z-index: 1000000;
}
</style>
